export const AdministrationMetadataPage = () =>
  import(
    /* webpackChunkName: "administration-module" */ "@/views/administration/metadata/Layout.vue"
  );
export const AdministrationMetadataGroupsPage = () =>
  import(
    /* webpackChunkName: "administration-module" */ "@/views/administration/metadata/MetadataGroups.vue"
  );
export const AdministrationMetadataFieldsPage = () =>
  import(
    /* webpackChunkName: "administration-module" */ "@/views/administration/metadata/MetadataFields.vue"
  );
export const AdministrationAppGroupsPage = () =>
  import(
    /* webpackChunkName: "administration-module" */ "@/views/administration/AppGroups.vue"
  );

export function registerAdministrationModule(r: any): any {
  if (r.length > 0 && r[0].children) {
    r[0].children = r[0].children.concat(
      {
        path: "/administration/metadata",
        component: AdministrationMetadataPage,
        children: [
          {
            path: "",
            redirect: "groups"
          },
          {
            path: "groups",
            component: AdministrationMetadataGroupsPage
          },
          {
            path: "fields",
            component: AdministrationMetadataFieldsPage
          }
        ]
      },
      {
        path: "/administration/groups",
        component: AdministrationAppGroupsPage
      }
    );
  }
  return r;
}
